import * as yup from 'yup';
import { error } from '../text';

const requiredValidation = yup.string().required(error.required);
const interestRateValidation = yup.string().nullable().max(2000, error.below2000);

const allowedFileTypes = ['application/pdf', 'image/png', 'image/jpeg', 'image/jpg'];
const maxFileSize = 7 * 1024 * 1024; // 7MB
const maxFiles = 30;
const demoMaxFiles = 100;

const maxCsvSize = 20 * 1024 * 1024; // 20MB
const allowedCsvTypes = ['text/csv'];

const imageValidation = yup
  .mixed<File[]>()
  .required(error.required)
  .test('fileType', error.invalidFileType, files =>
    files.every(file => allowedFileTypes.includes(file.type)),
  )
  .test('fileSize', error.maxSize, files => files.every(file => file.size <= maxFileSize))
  .test('fileCount', error.maxFiles, files => files.length <= maxFiles);

const demoImageValidation = yup
  .mixed<File[]>()
  .required(error.required)
  .test('fileType', error.invalidFileType, files =>
    files.every(file => allowedFileTypes.includes(file.type)),
  )
  .test('fileSize', error.maxSize, files => files.every(file => file.size <= maxFileSize))
  .test('fileCount', error.demoMaxFiles, files => files.length <= demoMaxFiles);

const csvValidation = yup
  .mixed<File[]>()
  .required(error.required)
  .test('fileType', error.invalidCsvType, files =>
    files.every(file => allowedCsvTypes.includes(file.type)),
  )
  .test('fileSize', error.csvMaxSize, files => files.every(file => file.size <= maxCsvSize))
  .test({
    name: 'fileEncoding',
    message: error.invalidEncoding,
    test: async function (files) {
      const isUtf8 = async (file: File): Promise<boolean> => {
        try {
          const arrayBuffer = await file.slice(0, 1024).arrayBuffer();
          new TextDecoder('utf-8', { fatal: true }).decode(new Uint8Array(arrayBuffer));
          return true;
        } catch {
          return false;
        }
      };

      const results = await Promise.all(files.map(isUtf8));
      return results.every(Boolean);
    },
  });

export const inputUploadSchema = yup.object().shape({
  images: imageValidation,
});

export const inputCsvUploadSchema = yup.object().shape({
  images: csvValidation,
});

export const DemoRegisterSchema = yup.object().shape({
  title: requiredValidation.max(250, error.below250),
  interestRate: interestRateValidation,
  file_type: yup.number().required(error.required),
  images: demoImageValidation,
});
